// Exports a helper for assembling a URL.

// TODO: This could probably be replaced by a more robust library such as https://www.npmjs.com/package/qs
function toQueryString(fields) {
  return Object.entries(fields).filter(([, value]) => Boolean(value)).map(([key, value]) => `${encodeURI(key)}=${encodeURIComponent(value)}`).join("&");
}
export default function buildURL(url, {
  pathname = "",
  search,
  hash = ""
}) {
  return `${url}${pathname}${search ? `?${toQueryString(search)}` : ""}${hash}`;
}